import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchMembers, fetchMembersInOrganisation } from '../../predict/src/core/api/members';
import { queryClient } from '../core/queryClient';

type FetchMembersResult = Awaited<ReturnType<typeof fetchMembersInOrganisation>>;
type FetchWorkspaceMembersResult = Awaited<ReturnType<typeof fetchMembers>>;
type MembersQueryOptions = Omit<QueryObserverOptions<FetchMembersResult>, 'queryKey' | 'queryFn'>;
type WorkspaceMembersQueryOptions = Omit<QueryObserverOptions<FetchWorkspaceMembersResult>, 'queryKey' | 'queryFn'>;

export const membersQueryKey = (organisationId: string, workspaceId: string, isConsolidation: boolean) => [
  'members',
  organisationId,
  workspaceId,
  isConsolidation
];

export const membersQuery = (
  workspaceId: string,
  organisationId: string,
  isConsolidation: boolean,
  options?: MembersQueryOptions
): QueryObserver<FetchMembersResult> =>
  new QueryObserver<FetchMembersResult>(queryClient, {
    queryKey: membersQueryKey(organisationId, workspaceId, isConsolidation),
    queryFn: () => fetchMembersInOrganisation(workspaceId, organisationId, isConsolidation),
    ...options
  });

export const workspaceMembersQueryKey = (workspaceId: string) => ['workspace-members', workspaceId];

export const workspaceMembersQuery = (
  workspaceId: string,
  options?: WorkspaceMembersQueryOptions
): QueryObserver<FetchWorkspaceMembersResult> =>
  new QueryObserver<FetchWorkspaceMembersResult>(queryClient, {
    queryKey: workspaceMembersQueryKey(workspaceId),
    queryFn: () => fetchMembers(workspaceId),
    ...options
  });

export const clearWorkspaceMembersQueryCache = (workspaceId: string): void => {
  queryClient.invalidateQueries({ queryKey: workspaceMembersQueryKey(workspaceId) });
};
